'use client';

import { useEffect } from 'react';
import { useSetState } from 'minimal-shared/hooks';

import axios from 'src/lib/axios';
import { supabase } from 'src/lib/supabase';

import { AuthContext } from '../auth-context';

// ----------------------------------------------------------------------

export function AuthProvider({ children }) {
  const { state, setState } = useSetState({ user: null, loading: true });

  const checkUserSession = async () => {
    try {
      const {
        data: { session },
        error,
      } = await supabase.auth.getSession();

      if (error) {
        setState({ user: null, loading: false });
        console.error(error);
        throw error;
      }

      if (session) {
        const accessToken = session?.access_token;

        setState({ user: { ...session, ...session?.user }, loading: false });
        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
      } else {
        setState({ user: null, loading: false });
        delete axios.defaults.headers.common.Authorization;
      }
    } catch (error) {
      console.error(error);
      setState({ user: null, loading: false });
    }
  };

  useEffect(() => {
    checkUserSession();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkAuthenticated = state.user ? 'authenticated' : 'unauthenticated';
  const status = state.loading ? 'loading' : checkAuthenticated;

  const contextValues = {
    user: state.user
      ? {
          ...state.user,
          id: state.user?.id,
          role: state.user?.role ?? 'admin',
          accessToken: state.user?.access_token,
          displayName: state.user?.user_metadata.display_name,
        }
      : null,
    checkUserSession,
    loading: status === 'loading',
    authenticated: status === 'authenticated',
  };

  return <AuthContext value={contextValues}>{children}</AuthContext>;
}
